var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RadioBTN"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 20,
    height: 20,
    rx: 10,
    fill: "#3DCF94"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 5,
    y: 5,
    width: 10,
    height: 10,
    rx: 5,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioOn);
export default __webpack_public_path__ + "static/media/Radio_on.63b18ffb998d80803f650f0e9a29b27e.svg";
export { ForwardRef as ReactComponent };